import { render, staticRenderFns } from "./XTree.vue?vue&type=template&id=05c92804&"
import script from "./XTree.vue?vue&type=script&lang=js&"
export * from "./XTree.vue?vue&type=script&lang=js&"
import style0 from "./XTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports